import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleSelectSiteUserGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../../settings/services/ServerSettingsUnauthenticated';
import { siteUserEditAuthentication } from '../actions/SiteUserMenuActions';
import { ISiteUserInfo } from '../models/ISiteUserInfo';

export const SiteUserSetAuthenticationAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserAuthentication,
  translateName: Messages.authentication_action,
  isVisible: (_targetItems: ISiteUserInfo[], _state: AppState) => {
    return ServerSettingsUnauthenticated.isSiteSamlEnabled();
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return targetItems.length > 0 && !isSingleSelectSiteUserGuest(targetItems);
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserEditAuthentication(targetItems)
};
